// extracted by mini-css-extract-plugin
module.exports = {"list":"CreateProductPage_list__13bt5","listContainer":"CreateProductPage_listContainer__wJNr2"};